"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useTheme.default;
  }
});

var _useTheme = _interopRequireDefault(require("./useTheme"));


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@material-ui+styles@4.11.5_@types+react@19.0.10_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@material-ui/styles/useTheme/index.js
// module id = 89
// module chunks = 0